
import List from './list.vue';
import Full from '@rebuild/materials/shared/investment_activity/ResearchIndex.vue';

export const componentMap = {
    list: List,
    full: Full
};
